import { client } from './client'
import type {
  Skill,
  SkillDetail,
  SkillVersion,
  CreateSkillRequest,
  CreateSkillResponse,
  UpdateSkillRequest,
  CreateSkillVersionRequest,
} from '@/types'

export const skillsApi = {
  getAll: (projectId: string) =>
    client.get<Skill[]>(`/projects/${projectId}/skills`).then(r => r.data),

  getById: (projectId: string, id: string) =>
    client.get<SkillDetail>(`/projects/${projectId}/skills/${id}`).then(r => r.data),

  create: (projectId: string, data: CreateSkillRequest) =>
    client.post<CreateSkillResponse>(`/projects/${projectId}/skills`, data).then(r => r.data),

  update: (projectId: string, id: string, data: UpdateSkillRequest) =>
    client.put(`/projects/${projectId}/skills/${id}`, data).then(r => r.data),

  delete: (projectId: string, id: string) =>
    client.delete(`/projects/${projectId}/skills/${id}`).then(r => r.data),

  createVersion: (projectId: string, id: string, data: CreateSkillVersionRequest) =>
    client.post<CreateSkillResponse>(`/projects/${projectId}/skills/${id}/versions`, data).then(r => r.data),

  getVersions: (projectId: string, id: string) =>
    client.get<SkillVersion[]>(`/projects/${projectId}/skills/${id}/versions`).then(r => r.data),

  getVersionById: (projectId: string, id: string, versionId: string) =>
    client.get<SkillVersion>(`/projects/${projectId}/skills/${id}/versions/${versionId}`).then(r => r.data),
}
